import { State, Effect, dispatch } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'

const SliderState = State({
  initial: {}
})

// eslint-disable-next-line
const sliderListEffect = Effect('sliderList', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}slider/list`)
})

export default SliderState



// WEBPACK FOOTER //
// ./src/states/slider.js